videojs.addLanguage('ru', {
  "Payment successfully completed": "Платеж успешно завершен",
  "Access code": "Код доступа",
  "Access code copy": "Копировать",
  "Access code copied": "Скопировано",
  "Сode copy to have access to the video": "Скопируйте этот код, чтобы иметь постоянный доступ к трансляции."
});